var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"east-img",style:({ width: _vm.imgWidth + 'px', height: _vm.imgHeight + 'px' })},[_c('img',{attrs:{"src":_vm.imgSrc}}),_vm._v(" "),_c('input',{ref:"file",attrs:{"type":"file","accept":_vm.imgMime,"title":"点击上传图片"},on:{"change":_vm.readImg}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d52083fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/east-img.vue
// module id = null
// module chunks = 